import './css/features.css'

export const KeyFeatures = () => {
    return (
        <div id="features">
            <div className="feature-inner">
                <h1 className="feature-title">Key Features</h1>

                <div className="feature-grid-container row">
                    {[
                        { title: "City Hub Aggregator", description: "Pull info from city websites, social media, and departments into one app", icon: "/images/icons/hubspot.svg" },
                        {
                            title: "Community Resources", description: `Browse vital services by
                                category-healthy living,
                                maternal & infant health,
                                HIV/STI, behavioral health,
                                community health and
                                more`, icon: "/images/icons/pen-nib.svg"
                        },
                        { title: "Polls & Surveys", description: "Gauge interest, collect insights, and shape programs with real-time feedback", icon: "/images/icons/poll-people.svg" },
                        { title: "Community Development", description: "Allow residents to suggest and vote on improvement ideas", icon: "/images/icons/group-arrows-rotate.svg" },
                        { title: "News & Events", description: "Push press releases and sync city calendars in one unified feed", icon: "/images/icons/news.svg" },
                        { title: "Push Notifications", description: "Deliver emergency alerts and time-sensitive updates instantly", icon: "/images/icons/bell.svg" },
                    ].map((feature, i) => (
                        <div key={i} className="feature-block col-12 col-lg-4">
                            <div className="d-none d-lg-block">
                                {i < 3 ? (
                                    <div className="feature-row">
                                        <img src={feature.icon} alt={`${feature.title} icon`} className="feature-icon" />
                                        <div className="feature-copy">
                                            <h5 className="feature-heading">{feature.title}</h5>
                                            <p className="feature-desc">{feature.description}</p>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                            <img src={feature.icon} alt={`${feature.title} icon`} className="feature-icon" />
                                            <h5 className="feature-heading">{feature.title}</h5>      {/* add class for consistency if desired */}
                                            <p className="feature-desc">{feature.description}</p>  
                                    </>
                                )}
                            </div>

                            <div className="d-lg-none">
                                <div className="feature-first-three">
                                    <div className="feature-header-inline">
                                        <img src={feature.icon} alt={`${feature.title} icon`} className="feature-icon" />
                                        <h5>{feature.title}</h5>
                                    </div>
                                    <p className="feature-desc">{feature.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
